import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=002de623&scoped=true&functional=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=002de623&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "002de623",
  null
  
)

export default component.exports